// debounce hook

import { useEffect, useMemo, useState } from "react";
import { axiosInstance } from "../service/apiClient";
import { asyncLocalStorage } from "../utils/func";

const useDebounce = (value, delay) => {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Only re-call effect if value or delay changes
  );

  return debouncedValue;
};

// with axios interceptor

const WithAxios = ({ children }) => {
  useMemo(() => {
    axiosInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        if (error.response.status === 401) {
          await asyncLocalStorage.clear();
          window.location.href = "/login";
        }
      }
    );
  }, []);

  return children;
};

export { useDebounce, WithAxios };

